export const APP_USER_ID = 'app-userId';
export const APP_UPDATE_TIME = 'upd-req-time';
export const PHOTO_CHECK = 'LS_my_photos_check';
export const SHOW_PREFERENCES = 'show-preferences';
export const SHOW_VERIFY = 'show-verify';
export const SHOW_DIAMOND_GIRLS = 'show-diamond-girls';
export const SHOW_VIP_DISCOUNT = 'show-vip-discount';
export const STORAGE_CUSTOM_ADM = 'app-admLoggedCheck';
export const ALLOW_PUSH_SCREEN = 'app-allow-push-screen';
